var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAiSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFB6BB"
    },
    points: "477.691,192.66 477.691,382.68 451.299,382.68 60.701,382.68 34.309,382.68 34.309,192.66  60.701,192.66 451.299,192.66 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDB51E"
    },
    points: "450.982,81.814 345.732,81.814 345.732,7.918 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.701,
    y: 382.68,
    style: {
      fill: "#FFD311"
    },
    width: 390.598,
    height: 121.402
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD311"
    },
    points: "451.299,82.026 451.299,192.66 60.701,192.66 60.701,7.918 345.732,7.918 345.732,81.814  450.982,81.814  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.701,
    y: 382.68,
    style: {
      fill: "#FDB51E"
    },
    width: 195.299,
    height: 121.402
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.701,
    y: 7.918,
    style: {
      fill: "#FDB51E"
    },
    width: 195.299,
    height: 184.742
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0A7AB"
    },
    points: "477.691,192.66 451.299,192.66 60.701,192.66 34.309,192.66 34.309,292.948 477.691,292.948  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M200.577,95.01V58.062h-52.784V36.948H89.732V95.01h58.062V73.897h36.948V95.01h-21.113v58.062 h58.062V95.01H200.577z M131.959,79.175h-26.392V52.784h26.392V79.175z M205.856,137.237h-26.392v-26.392h26.392V137.237z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.485,
    y: 432.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 285.031,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.464,
    y: 216.412,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.464,
    y: 343.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.423,
    y: 343.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.423,
    y: 216.412,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.608,184.742h-26.392V77.792L348.234,0H52.784v184.742H26.392v205.856h26.392V512h406.433V390.598h26.392V184.742z  M353.65,23.151l72.277,50.746H353.65V23.151z M68.619,15.835h269.196v73.897h105.567v95.01H68.619V15.835z M443.381,496.165H68.619 V390.598h374.763V496.165z M469.773,374.763H42.227V200.577h427.546V374.763z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.277,300.866h64.994l18.166,47.685l14.798-5.637l-44.17-115.944h-42.584l-44.169,115.944l14.798,5.637L181.277,300.866z  M203.395,242.804h20.757l16.086,42.227h-52.929L203.395,242.804z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 295.588,
    y: 224.33,
    width: 15.835,
    height: 126.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAiSvgrepoCom);
export default __webpack_public_path__ + "static/media/ai-ai-svgrepo-com.967b491bd3d92c2239aa5fe461469119.svg";
export { ForwardRef as ReactComponent };